import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController } from 'ionic-angular';
import { Storage } from '@ionic/storage';
import { FenstertypPage } from '../fenstertyp/fenstertyp';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppConfig } from '../../app/app-config';
import { UserserviceProvider } from '../../providers/userservice';
@Component({
  selector: 'page-system',
  templateUrl: 'system.html',
})
export class SystemPage {
producttype: string;
productname: string;
loading: any;
category_id: any;
public basket: Array<string> = new Array();
//public basket: Array<{key:string, value:string}> = new Array();
  constructor(public navCtrl: NavController, public navParams: NavParams, public storage: Storage, public http: HttpClient, public appConfig: AppConfig, public userService: UserserviceProvider, public loadingCtrl: LoadingController) {
     
  //  this.storage.get('Produkt').then((val) => {
  //    console.log('Your product is', val);
  //});
  
  this.producttype = this.navParams.get('producttype');
  console.log(this.producttype); 
  this.category_id = this.navParams.get('category_id');
  //console.log(this.category_id); 
  //this.basket.push({"producttype":this.producttype});
  //this.basket.push({"producttype2":this.producttype});
  //console.log(this.basket); 
  }
  
      clickwindowtype(productname) {
    this.navCtrl.push(FenstertypPage, {
    productname: productname,
    producttype: this.producttype
    });
  }
  
     ionViewWillEnter() : void
   {
      this.getProduct();
   }
  
  getProduct(){
  this.presentLoading();
  this.userService.getProducts(this.category_id).subscribe((data : any) =>
      {
          this.items = data;
          console.dir(data);
          this.loading.dismiss();
      },
      (error : any) =>
      {
         console.dir(error);
        this.loading.dismiss();
      });
        }
        

    presentLoading() {

        this.loading = this.loadingCtrl.create({
            content: 'Please wait...'
        });
        this.loading.present();
    }
    
       doRefresh(refresher) {
   this.getProduct();
   refresher.complete();
   }


}



// WEBPACK FOOTER //
// ./src/pages/system/system.ts